/* eslint-disable max-len */
import React from 'react';
function Timesheet() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 9H17.5V5L14.5 2H4C3.33333 2 2 2.4 2 4V20C2 20.6667 2.4 22 4 22H12C11.2 21.6 10.5 20.5 10.5 20H4V4H13.5V6H15.5V9ZM10.5 16C10.5 12.7 13.2 10 16.5 10C19.8 10 22.5 12.7 22.5 16C22.5 19.3 19.8 22 16.5 22C13.2 22 10.5 19.3 10.5 16ZM12.5 16C12.5 18.2 14.3 20 16.5 20C18.7 20 20.5 18.2 20.5 16C20.5 13.8 18.7 12 16.5 12C14.3 12 12.5 13.8 12.5 16ZM15.8 13H17.3H17.4V15.6L19.6 16.9L18.8 18.2L17.3 17.3L15.8 16.4V14.7V13Z" })));
}
export default Timesheet;
